import { jsx, jsxs } from "react/jsx-runtime";
const SvgLogout = (props) => /* @__PURE__ */ jsxs("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx("path", { d: "M5 5H12V3H3V21H12V19H5V5Z", fill: "currentColor" }),
  /* @__PURE__ */ jsx("path", { d: "M21 12L17 8V11H9V13H17V16L21 12Z", fill: "currentColor" })
] });
export default SvgLogout;
